import styled from 'styled-components';

export const ConflictTemplatesMessage = styled.div`
    font-size: 16px;
    text-align: justify;
    line-height: 1.25;
    font-weight: 400;
`;
